<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-18 10:08:19
 * @LastEditors: 陈钊贤
 * @Description: 
 * @LastEditTime: 2020-11-25 11:18:33
--> 
<template>
  <div id="app" class="page_parent">
    <pi-activity v-if="app.userInfo"></pi-activity>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <router-view /> -->
    <!--<back-Button></back-Button>-->
  </div>
</template>

<script>
import backButton from "@/components/back-Button";
import piActivity from "@/components/pi-activity/pi-activity";
import { mapState } from "vuex";
export default {
  components: {
    [backButton.name]: backButton,
    [piActivity.name]: piActivity,
  },
  mounted() {},
  watch: {},

  methods: {},
  computed: {
    ...mapState(["app"]),
  },
};
</script>

<style>
body {
  font-size: 0.28rem;
  height: 100%;
  background-color: white;
  -webkit-font-smoothing: antialiased;
}
</style>


